import React from 'react';
import {ProspectPool} from 'api';

interface Props {
  prospectPool: ProspectPool;
}

export const DepartmentPositionComponent = ({prospectPool}: Props) => {
  const section = prospectPool.prospect?.section;
  const sectionPosition = prospectPool.prospect?.sectionPosition;

  if (!section && !sectionPosition) {
    return null;
  }

  return (
    <div className="flex items-center gap-4 text-foreground text-sm">
      {section && <span>{section}</span>}
      {sectionPosition && <span>{sectionPosition}</span>}
    </div>
  );
};
